module.exports = __webpack_public_path__ + "img/x1.2_ade01406c.png";